/* eslint-disable */ import { DomainEntityReflection, RawAliasReflection, SchemaReflection } from '@salsita-ai/platform-project-sdk/domain';
export const modelVersion = 1;
export const GenericDomainEntity = new SchemaReflection('GenericDomainEntity', {
    type: 'object',
    properties: {
        id: {
            type: 'string',
            pattern: '^[A-Z]\\w*-\\d+$'
        },
        type: {
            type: 'string'
        }
    },
    additionalProperties: true,
    required: [
        'id',
        'type'
    ]
});
export const RecipeConfiguration = new SchemaReflection('RecipeConfiguration', {
    type: 'object',
    properties: {
        modelVersion: {
            type: 'integer'
        },
        entities: {
            type: 'array',
            items: GenericDomainEntity._meta.schema
        },
        rootEntityType: {
            type: 'string'
        },
        rootRecipeId: {
            type: 'string'
        },
        recipeIds: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        configurationId: {
            type: 'string'
        },
        revisionId: {
            type: 'string'
        },
        ownerToken: {
            type: 'string'
        }
    },
    additionalProperties: false,
    required: [
        'entities',
        'rootEntityType',
        'rootRecipeId',
        'recipeIds',
        'modelVersion',
        'configurationId',
        'revisionId',
        'ownerToken'
    ]
});
const CommonAdminEntityShape = new SchemaReflection('CommonAdminEntityShape', {
    type: 'object',
    properties: {
        commonAdminModelVersion: {
            enum: [
                4
            ]
        }
    },
    additionalProperties: false,
    required: [
        'commonAdminModelVersion'
    ]
});
const PresetCategoryShape = new SchemaReflection('PresetCategoryShape', {
    type: 'object',
    properties: {
        name: {
            type: 'object',
            properties: {
                $lang: {
                    type: 'object',
                    additionalProperties: {
                        type: 'string'
                    }
                }
            },
            required: [
                '$lang'
            ],
            additionalProperties: false
        },
        index: {
            type: 'number'
        },
        visible: {
            type: 'boolean'
        },
        description: {
            type: 'object',
            properties: {
                $lang: {
                    type: 'object',
                    additionalProperties: {
                        type: 'string'
                    }
                }
            },
            required: [
                '$lang'
            ],
            additionalProperties: false
        }
    },
    additionalProperties: false,
    required: [
        'name',
        'index',
        'visible',
        'description'
    ]
});
const PresetShape = new SchemaReflection('PresetShape', {
    type: 'object',
    properties: {
        name: {
            type: 'object',
            properties: {
                $lang: {
                    type: 'object',
                    additionalProperties: {
                        type: 'string'
                    }
                }
            },
            required: [
                '$lang'
            ],
            additionalProperties: false
        },
        description: {
            type: 'object',
            properties: {
                $lang: {
                    type: 'object',
                    additionalProperties: {
                        type: 'string'
                    }
                }
            },
            required: [
                '$lang'
            ],
            additionalProperties: false
        },
        index: {
            type: 'number'
        },
        visible: {
            type: 'boolean'
        },
        categoryId: {
            oneOf: [
                {
                    type: 'string',
                    pattern: '^[A-Z]\\w*-\\d+$'
                },
                {
                    type: 'null'
                }
            ]
        },
        configurationId: {
            type: [
                'string',
                'null'
            ]
        },
        revisionId: {
            type: [
                'string',
                'null'
            ]
        },
        ownerToken: {
            type: [
                'string',
                'null'
            ]
        },
        readToken: {
            type: [
                'string',
                'null'
            ]
        },
        thumbnailUrl: {
            type: [
                'string',
                'null'
            ]
        },
        tags: {
            type: 'array',
            items: {
                type: 'string'
            }
        }
    },
    additionalProperties: false,
    required: [
        'name',
        'description',
        'index',
        'visible',
        'categoryId',
        'configurationId',
        'revisionId',
        'ownerToken',
        'readToken',
        'thumbnailUrl',
        'tags'
    ]
});
const DataTableShape = new SchemaReflection('DataTableShape', {
    type: 'object',
    properties: {
        dataEntryKey: {
            type: 'string'
        },
        data: {
            type: 'object'
        }
    },
    additionalProperties: false,
    required: [
        'dataEntryKey',
        'data'
    ]
});
const ConnectedDataConfigShape = new SchemaReflection('ConnectedDataConfigShape', {
    type: 'object',
    properties: {
        dataEntryKey: {
            type: 'string'
        },
        provider: {
            type: 'string'
        },
        externalFileId: {
            type: 'string'
        },
        fileLabel: {
            type: 'string'
        },
        driveId: {
            type: [
                'string',
                'null'
            ]
        },
        tabSelection: {
            type: 'array',
            items: {
                type: 'string'
            }
        }
    },
    additionalProperties: false,
    required: [
        'dataEntryKey',
        'provider',
        'externalFileId',
        'fileLabel',
        'driveId',
        'tabSelection'
    ]
});
const RecipeShape = new SchemaReflection('RecipeShape', {
    type: 'object',
    properties: {
        name: {
            type: 'object',
            properties: {
                $lang: {
                    type: 'object',
                    additionalProperties: {
                        type: 'string'
                    }
                }
            },
            required: [
                '$lang'
            ],
            additionalProperties: false
        },
        description: {
            type: 'object',
            properties: {
                $lang: {
                    type: 'object',
                    additionalProperties: {
                        type: 'string'
                    }
                }
            },
            required: [
                '$lang'
            ],
            additionalProperties: false
        },
        collection: {
            type: 'string'
        },
        index: {
            type: 'number'
        },
        visible: {
            type: 'boolean'
        },
        configuration: {
            anyOf: [
                RecipeConfiguration._meta.schema,
                {
                    type: 'null'
                }
            ]
        }
    },
    additionalProperties: false,
    required: [
        'name',
        'description',
        'collection',
        'index',
        'visible',
        'configuration'
    ]
});
const PricingSettingsShape = new SchemaReflection('PricingSettingsShape', {
    type: 'object',
    properties: {
        data: {
            type: 'string'
        }
    },
    additionalProperties: false,
    required: [
        'data'
    ]
});
export const Admin = new DomainEntityReflection('Admin', [
    CommonAdminEntityShape._meta.schema
]);
export const Preset = new DomainEntityReflection('Preset', [
    PresetShape._meta.schema,
    CommonAdminEntityShape._meta.schema
]);
export const PresetCategory = new DomainEntityReflection('PresetCategory', [
    PresetCategoryShape._meta.schema,
    CommonAdminEntityShape._meta.schema
]);
export const Recipe = new DomainEntityReflection('Recipe', [
    RecipeShape._meta.schema,
    CommonAdminEntityShape._meta.schema
]);
export const ConnectedDataConfig = new DomainEntityReflection('ConnectedDataConfig', [
    ConnectedDataConfigShape._meta.schema,
    CommonAdminEntityShape._meta.schema
]);
export const DataTable = new DomainEntityReflection('DataTable', [
    DataTableShape._meta.schema,
    CommonAdminEntityShape._meta.schema
]);
export const DummyDoNotUse = new DomainEntityReflection('DummyDoNotUse', []);
export const PricingSettings = new DomainEntityReflection('PricingSettings', [
    PricingSettingsShape._meta.schema
]);
export const AnyDomainEntity = new RawAliasReflection('AnyDomainEntity', [
    Admin,
    Preset,
    PresetCategory,
    Recipe,
    ConnectedDataConfig,
    DataTable,
    DummyDoNotUse,
    PricingSettings
]);
export const RootEntity = new RawAliasReflection('RootEntity', [
    Admin
]);
export const CommonAdminEntity = new RawAliasReflection('CommonAdminEntity', [
    Admin,
    Preset,
    PresetCategory,
    Recipe,
    ConnectedDataConfig,
    DataTable
]);
export const aliases = {
    AnyDomainEntity: AnyDomainEntity.types,
    RootEntity: RootEntity.types,
    CommonAdminEntity: CommonAdminEntity.types
};
export const entities = {
    Admin,
    Preset,
    PresetCategory,
    Recipe,
    ConnectedDataConfig,
    DataTable,
    DummyDoNotUse,
    PricingSettings
};

//# sourceMappingURL=v1.js.map